import React from 'react'

import { Typography, Box, makeStyles, Button, CircularProgress } from '@material-ui/core'

interface ActionProps {
  icon?: React.ReactElement
  label?: string
  onClick: () => void
  disabled?: boolean
  isLoading?: boolean
}

const useStyles = makeStyles((theme) => ({
  buttonsWrapper: {
    marginRight: theme.spacing(4),
  },
  loadingButton: {
    color: theme.palette.secondary.main,
  },
  loadingBox: {
    '&:hover': {
      cursor: 'wait',
    },
  },
}))

const Action: React.FC<ActionProps> = ({ icon, label, onClick, disabled, isLoading }) => {
  const classes = useStyles()

  return (
    <Button
      data-hook={`button-${label}`}
      className={classes.buttonsWrapper}
      size="small"
      variant="outlined"
      color="secondary"
      onClick={onClick}
      disabled={disabled}
      key={label}
    >
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box lineHeight={1} mr={1}>
          {icon}
        </Box>
        {label && <Typography variant="h5">{label}</Typography>}
        {isLoading && (
          <Box className={classes.loadingBox} width="157px">
            <CircularProgress className={classes.loadingButton} size={20} />
          </Box>
        )}
      </Box>
    </Button>
  )
}

export default Action
